import Fetch, { pageInfo } from './fetch';
import Qs from 'qs'

const attendanceRequest = {
    /**
     * 考勤查询展示表格
     * */
    getCheckinList(key, page, size) {
        return Fetch({
            url: '/dormitory/getCheckinList?'+key+ pageInfo(page, size),
            method: 'get'
            // data:
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
        });
    },
    adjustBedTargetDormitory(str, page, size){
        return Fetch({
            url: '/dormitory/adjustBedTargetDormitory?'+str+ pageInfo(page, size),
            method: 'get'
            // data:
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
        });
    },
    batchAdjustBed(formdata){
        return Fetch({
            url: '/dormitory/batchAdjustBed',
            method: 'post',
            data:formdata
            // data:
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
        });
    },


//GET /dormitory/waitCheckinList

    getWaitCheckinList(str,page,size){
      return Fetch({
        url: '/dormitory/waitCheckinList?' + str + pageInfo(page, size),
        method:'get'
    });
    },

    //// GET /house/getAllHouseBySchool
  getAllHouseBySchool(str){
    return Fetch({
      url: '/house/getAllHouseBySchool?' +str,
      method:'get'
    });
  },

  // GET /house/queryHouseByManagerUser
  queryHouseByManagerUser(){
    return Fetch({
      url: '/house/queryHouseByManagerUser',
      method:'get'
    });
  },



  //GET /floor/getFloorListByHouseId
  getFloorListByHouseId(houseId){
    return Fetch({
      url: '/floor/getFloorListByHouseId?houseId=' +houseId,
      method:'get'
    });
  },





//   GET /house/getNoUseBedTotal
// 查楼栋空余床位数量
    getNoUseBedTotal(houseId){
      return Fetch({
        url: '/house/getNoUseBedTotal?houseId=' +houseId,
        method:'get'
      });
    },
//   GET /dormitory/emptyBedDormitoryList
// 有空余床位寝室列表
  emptyBedDormitoryList(str){
    return Fetch({
      url: '/dormitory/emptyBedDormitoryList?' +str,
      method:'get'
    });
  },

  //GET /school/querySchoolCapmus
  //查询校区
  querySchoolCapmus(){
    return Fetch({
      url: '/school/querySchoolCapmus',
      method:'get'
    });
  },


  //自动排宿
  autoCheckinDormitory(data){
    return Fetch({
      url: '/dormitory/autoCheckinDormitory',
      method:'post',
      data:data
    });
},

//获取自动排宿的进度
    getAutoCheckinProcess (key){
    return Fetch({
      url: '/dormitory/getAutoCheckinProcess?redisKey='+ key,
      method:'get',
      headers: { showLoading: false }
    });
  },

    //获取批量退宿的进度GET
    getBatchCheckOutProcess (key) {
        return Fetch({
            url: '/dormitory/getBatchCheckOutProcess?redisKey=' + key,
            method: 'get',
            headers: { showLoading: false }
        });
    },
  // 单个排宿
  singleCheckIn(data){
    return Fetch({
      url: '/dormitory/singleCheckIn?'+data,
      method:'post',
    });
  },

  //批量排宿
 // POST /dormitory/batchCheckIn
  batchCheckIn(data){
    return Fetch({
      url: '/dormitory/batchCheckIn',
      method:'post',
      data:data
    });
  },
  /**
   * 导入已入住的学生   POST /importData/importOldCheckinStudent
   * */
  importOldCheckinStudent(file) {
    return Fetch({
      url: '/importData/importOldCheckinStudent',
      headers: { 'Content-Type': 'application/formData' },
      method: 'post',
      data: file
    });
  },
  // GET /exportData/exportWaitCheckinList
  exportWaitCheckinList(str,pageNum,pageSize){
    return Fetch({
      url: '/exportData/exportWaitCheckinList?'+str+pageInfo(pageNum,pageSize),
      method:'get'
    });
  },
  statisSchoolBedList(str){
    return Fetch({
      url:'/bed/statisSchoolBedList?'+str,
      method:'get'
    })
  },
  statisSchoolBuildDetaiList(str,page,size){
    return Fetch({
      url:'/bed/statisSchoolBuildDetaiList?'+ str + pageInfo(page, size),
      method:'get'
    })
  },
  statisSchoolFloorDetaiList(str,page,size){
    return Fetch({
      url:'/bed/statisSchoolFloorDetaiList?'+ str + pageInfo(page, size),
      method:'get'
    })
  },
  exportStatisSchoolBedList(str){
    return Fetch({
      url:'/exportData/exportStatisSchoolBedList?'+str,
      method:'get',
      responseType :'blob'
    })
  },
  exportStatisSchoolBuildDetaiList(str){
    return Fetch({
      url:'/exportData/exportStatisSchoolBuildDetaiList?'+str,
      method:'get',
      responseType:'blob'
    })
  },
  exportStatisSchoolFloorDetaiList(str){
    return Fetch({
      url:"/exportData/exportStatisSchoolFloorDetaiList?"+str,
      method:'get',
      responseType:'blob'
    })
    },
    againSendStudentToHKVS () {
        return Fetch({
            url: '/dormitory/againSendStudentToHKVS',
            method: 'post',
            data: {
                batchType:3
            }
        });
    },
    getAgainSendStudentToHKVSProcess (key) {
        return Fetch({
            url: '/dormitory/getAgainSendStudentToHKVSProcess?redisKey=' + key,
            method: 'get',
            headers: { showLoading: false }
        });
    },
    /**
     * K12毕业学生退宿
     * **/
    cleanK12BiyeStuRoom () {
        return Fetch({
            url: '/dormitory/cleanK12BiyeStuRoom',
            method: 'post',
        });
    },
    checkCleanK12Stu () {
        return Fetch({
            url: '/dormitory/checkCleanK12Stu',
            method: 'get',
            headers: { showLoading: false }
        });
    },
}

export default attendanceRequest;



// WEBPACK FOOTER //
// ./src/api/AccommodationManagement.js